import { QC_TASK_REPORT_TABS } from '../constants/qcTaskReportConstants';

/**
 * @param {string | null} raw - `searchParams.get('tab')`
 * @returns {keyof typeof QC_TASK_REPORT_TABS}
 */
export function normalizeReportTabFromSearchParam(raw) {
  const tab = (raw ?? QC_TASK_REPORT_TABS.APPROVED).toUpperCase();
  if (
    tab === QC_TASK_REPORT_TABS.APPROVED ||
    tab === QC_TASK_REPORT_TABS.REJECTED
  ) {
    return tab;
  }
  return QC_TASK_REPORT_TABS.APPROVED;
}
